// Shared constants and helpers for Play Mode Sheet components
import { SKILL_NAMES, SKILL_ABILITY_MAP, type SkillName } from '@character-creator/types';

export const ABILITY_LABELS: Record<string, string> = {
  strength: 'STR',
  dexterity: 'DEX',
  constitution: 'CON',
  intelligence: 'INT',
  wisdom: 'WIS',
  charisma: 'CHA',
};

/** Convert kebab-case skill name to display title (e.g., "animal-handling" → "Animal Handling") */
function formatSkillName(skill: SkillName): string {
  return skill.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

/** Derived from SKILL_NAMES + SKILL_ABILITY_MAP in types package. */
export const SKILLS: { name: string; ability: string; skillId: SkillName }[] = SKILL_NAMES.map(
  (skill) => ({
    name: formatSkillName(skill),
    ability: SKILL_ABILITY_MAP[skill],
    skillId: skill,
  }),
);

// Format condition name for display (kebab-case to Title Case)
export const formatConditionName = (condition: string): string => {
  return condition.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

// Currency display helpers
export const COIN_NAMES: Record<string, { name: string; color: string }> = {
  gp: { name: 'Gold', color: 'text-accent-gold' },
  sp: { name: 'Silver', color: 'text-text-secondary' },
  cp: { name: 'Copper', color: 'text-class-fighter' },
  ep: { name: 'Electrum', color: 'text-class-bard' },
  pp: { name: 'Platinum', color: 'text-class-paladin' },
};
